export default __webpack_public_path__ + "static/media/oil-rig-crop.d031af3f.jpg";